import { render, staticRenderFns } from "./IRCLicenseActions.vue?vue&type=template&id=35d5e025&scoped=true"
import script from "./IRCLicenseActions.vue?vue&type=script&lang=js"
export * from "./IRCLicenseActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d5e025",
  null
  
)

export default component.exports